export default __webpack_public_path__ + "static/BT_Benefits_Carousel_02-faedc4399457fce4f2fa0024d032f72d.png";